import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'
import EmblaCarousel from 'embla-carousel';
import {CountUp} from "countup.js";

// Embla Carousel.
window.EmblaCarousel = EmblaCarousel;

// Alpine.js
window.Alpine = Alpine;
Alpine.plugin(collapse)
Alpine.start();

// Statistics block
const countupElements = document.querySelectorAll('.countup-number');

countupElements.forEach(element => {
    const endVal = parseFloat(element.textContent);
    const options = {
        duration: 2, // Example duration
        enableScrollSpy: true, // Example: start animation when element is in view
        scrollSpyOnce: true // Example: only animate once
    };

    const countUp = new CountUp(element, endVal, options);

    if (!countUp.error) {
        // If using enableScrollSpy, you don't need to call start() manually here
        // countUp.start();
    } else {
        console.error(countUp.error);
    }
});

// Mobile menu prevent scrolling
const menuBtn = document.querySelector('.mobile-nav-menu');
const body = document.querySelector('body');

menuBtn.addEventListener('click', () => {
    body.classList.toggle('no-scroll');
});

jQuery(document).ready(function ($) {
    var ajax_is_in_progress;
    var current_page = 1;
    // Accessibility menu
    $('.parent-menu').on('keydown', function (event) {
        var isSpaceKey = event.code === 'Space' || event.key === ' ' || event.key === 'Spacebar';

        if (isSpaceKey) {
            event.preventDefault();
            // close open menus
            $('.dropdown-menu').each(function (index, element) {
                element.dispatchEvent(new MouseEvent('mouseleave'));
            });

            var elm = $(this).closest('.dropdown-menu').get(0);

            if (elm) {
                elm.dispatchEvent(new MouseEvent('mouseenter'));
            }
        }
    });

    // close menu on escape key
    $("body").keyup(function(event) {
        if (event.code === 'Escape') {
            $('.dropdown-menu').each(function (index, element) {
                element.dispatchEvent(new MouseEvent('mouseleave'));
            });
        }
    });

    // Program filters for mobile
    $('#filter-button').click(function (e) {
        e.preventDefault();
        $('#filter-fields').animate({ width: 'show',opacity: '1' }, 500);
    });
    $('#filter-close').click(function (e) {
        e.preventDefault();
        $('#filter-fields').animate({ width: 'hide',opacity: '0' }, 500);
    });

    $('.close-filter-item').click(function (e) {
        e.preventDefault();
        var id = $(this).data("id");
        var elm_id = 'filter-'+id;
        $('#'+elm_id).prop('checked', false);
        $('#program-filters').submit();
    });

    // Submit program filters form on Enter key
    $('#program-filters').on('keypress', function (e) {
        if (e.which === 13) { // 13 is the Enter key code
            e.preventDefault();
            $(this).submit();
        }
    });

    // Internal Menu activation toggle
    $("#sidebar-button").click(function () {
        $("#internal-menu").slideToggle();
        $("#sidebar-button-indicator").text($("#sidebar-button-indicator").text() === '+' ? "-" : "+");
    });

    // Dropdown menu hover toggle with slide and fade
    /*$(document).on('mouseenter', '.dropdown-menu', function() {

        $(this).find('.dropdown-menu-content')
            .removeClass('pointer-events-none')
            .stop(true, true)
            .slideDown(250, function() {
                $(this).animate({opacity: 1}, 200);
            });
    });

    $(document).on('mouseleave', '.dropdown-menu', function() {
        $(this).find('.dropdown-menu-content')
            .stop(true, true)
            .slideUp(200, function() {
                $(this).addClass('opacity-0 pointer-events-none');
            });
    });*/

});

document.addEventListener('DOMContentLoaded', () => {
    initSearchKeyboardNav();
    initNewsVideoModal();
});

// Keyboard Navigation for Relevanssi Live Ajax Search
function initSearchKeyboardNav() {
    // Find all search inputs
    const searchInputs = document.querySelectorAll('input.main-search');

    if (!searchInputs.length) return;

    searchInputs.forEach((searchInput) => {
        let currentFocusIndex = -1;
        let searchResults = [];

        searchInput.addEventListener('keydown', (e) => {
            searchResults = document.querySelectorAll('.relevanssi-live-search-result');

            if (!searchResults.length) return;

            switch(e.key) {
                case 'Tab':
                    e.preventDefault();
                    // Tab moves forward, Shift+Tab moves backward

                    if (e.shiftKey) {
                        currentFocusIndex = Math.max(currentFocusIndex - 1, -1);
                        if (currentFocusIndex === -1) {
                            searchInput.focus();
                        } else {
                            focusResult(currentFocusIndex);
                        }
                    } else {
                        // If at the end of the list, allow default Tab behavior
                        if (currentFocusIndex >= searchResults.length - 1) {
                            closeDropdown();
                            currentFocusIndex = -1;
                            // Don't prevent default - let Tab move to next element
                            return;
                        }

                        currentFocusIndex = Math.min(currentFocusIndex + 1, searchResults.length - 1);
                        focusResult(currentFocusIndex);
                    }
                    break;

                case 'Enter':
                    if (currentFocusIndex === -1) return;
                    e.preventDefault();
                    navigateHighlightedResult(searchResults[currentFocusIndex]);
                    break;

                case 'Escape':
                    e.preventDefault();
                    closeDropdown();
                    currentFocusIndex = -1;
                    break;
            }
        });

        // Reset index when dropdown opens/closes
        searchInput.addEventListener('input', () => {
            currentFocusIndex = -1;
        });

        function navigateHighlightedResult(fallbackResult) {
            const highlightedResult = document.querySelector(
                '.relevanssi-live-search-results-showing .relevanssi-live-search-result--focused a[href], ' +
                '.relevanssi-live-search-results-showing .relevanssi-live-search-result[aria-selected="true"] a[href], ' +
                '.relevanssi-live-search-results-showing .relevanssi-live-search-result-link.focused[href]'
            ) || fallbackResult;

            if (highlightedResult && highlightedResult.href) {
                window.location.assign(highlightedResult.href);
            }
        }

        function focusResult(index) {
            searchResults.forEach((item, i) => {
                const pElement = item.querySelector('a');
                if (i === index) {
                    item.classList.add('focused');
                    if (pElement) {
                        pElement.classList.add('focused');
                    }
                    item.setAttribute('aria-selected', 'true');
                    item.scrollIntoView({ block: 'nearest' });
                    console.log('Focused element:', pElement || item, 'Classes:', (pElement || item).className);
                } else {
                    item.classList.remove('focused');
                    if (pElement) {
                        pElement.classList.remove('focused');
                    }
                    item.removeAttribute('aria-selected');
                }
            });
        }

        function closeDropdown() {
            // Find the dropdown that comes after this specific search input
            const dropdown = document.querySelector('.relevanssi-live-search-results-showing');

            if (dropdown) {
                dropdown.classList.remove('relevanssi-live-search-results-showing');
                console.log(dropdown);
            }

            // Remove all focused states
            searchResults.forEach((item) => {
                item.classList.remove('focused');
                const pElement = item.querySelector('a');
                if (pElement) {
                    pElement.classList.remove('focused');
                }
                item.removeAttribute('aria-selected');
            });
        }
    });
}

function initNewsVideoModal() {
    const modal = document.querySelector('.news-video-modal');

    if (!modal) return;

    const iframe = modal.querySelector('.news-video-modal__iframe');
    const closeButton = modal.querySelector('.news-video-modal__close');
    let previousFocus = null;

    function getYouTubeEmbedUrl(videoUrl) {
        try {
            const url = new URL(videoUrl);
            let videoId = '';

            if (url.hostname.includes('youtu.be')) {
                videoId = url.pathname.split('/').filter(Boolean)[0] || '';
            } else if (url.pathname.includes('/embed/')) {
                videoId = url.pathname.split('/embed/')[1].split('/')[0] || '';
            } else if (url.pathname.includes('/shorts/')) {
                videoId = url.pathname.split('/shorts/')[1].split('/')[0] || '';
            } else {
                videoId = url.searchParams.get('v') || '';
            }

            if (!videoId) return '';

            return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        } catch (error) {
            return '';
        }
    }

    function openModal(videoUrl) {
        const embedUrl = getYouTubeEmbedUrl(videoUrl);

        if (!embedUrl) return;

        previousFocus = document.activeElement;
        iframe.src = embedUrl;
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
        closeButton.focus();
    }

    function closeModal() {
        iframe.src = '';
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');

        if (previousFocus && typeof previousFocus.focus === 'function') {
            previousFocus.focus();
        }
    }

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-video-url]');

        if (!trigger) return;

        event.preventDefault();
        openModal(trigger.dataset.videoUrl);
    });

    document.addEventListener('keydown', (event) => {
        const trigger = event.target.closest('[data-video-url]');

        if (trigger && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            openModal(trigger.dataset.videoUrl);
            return;
        }

        if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeModal();
        }
    });

    closeButton.addEventListener('click', closeModal);

    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            closeModal();
        }
    });
}

const element = document.getElementById('news-filters');
if (element !== null) {
    document.getElementById('news-filters').addEventListener('submit', function(e) {
        // Get all checked news_type checkboxes
        const checkedBoxes = Array.from(document.querySelectorAll('.news-type-checkbox:checked'))
            .map(checkbox => checkbox.value)
            .filter(value => value !== ''); // Exclude empty value from "All"

        // Remove all existing news_type inputs
        document.querySelectorAll('input[name="news_type"]').forEach(input => {
            input.remove();
        });

        // Create a single hidden input with comma-separated values
        if (checkedBoxes.length > 0) {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'news_type';
            hiddenInput.value = checkedBoxes.join(',');
            this.appendChild(hiddenInput);
        }
    });
}


jQuery(function ($) {
    var $form = $('#news-filters');
    if (!$form.length) return;

    function getGroup($cb) {
        var name = $cb.attr('name');
        return name
            ? $form.find('input[type="checkbox"][name="' + name.replace(/"/g, '\\"') + '"]')
            : $();
    }

    function getGroupByName(name) {
        return $form.find('input[type="checkbox"][name="' + name.replace(/"/g, '\\"') + '"]');
    }

    function submitFilters() {
        $form.trigger('submit');
    }

    // Checkbox logic
    $form.on('change', 'input[type="checkbox"]', function () {
        var $cb = $(this);
        var $group = getGroup($cb);
        if (!$group.length) return;

        var $all = $group.filter('[value="all"]');

        // Clicked "all"
        if ($cb.val() === 'all') {
            if ($cb.is(':checked')) {
                $group.not($cb).prop('checked', false);
            }
            return;
        }

        // Clicked single
        if ($cb.is(':checked') && $all.length) {
            $all.prop('checked', false);
        }
    });

    // Initial state
    var seen = {};
    $form.find('input[type="checkbox"][name]').each(function () {
        var name = this.name;
        if (seen[name]) return;
        seen[name] = true;

        var $group = getGroupByName(name);
        var $all = $group.filter('[value="all"]');

        if ($all.length && $all.is(':checked')) {
            $group.not($all).prop('checked', false);
        }
    });

    // Selected filter
    var filterMap = {
        type: 'news_type'
    };

    $(document).on('click', '.selected-filters .filters-close', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $chip = $(this).closest('[data-filter][data-value]');
        if (!$chip.length || $chip.data('removing')) return;

        $chip.data('removing', true);

        var filterMap = {
            type: 'news_type'
        };

        var filterKey = String($chip.data('filter'));
        var value = String($chip.data('value'));
        var inputName = filterMap[filterKey];

        if (!inputName) return;

        var $group = getGroupByName(inputName);
        if (!$group.length) return;

        // Uncheck dropdown
        $group.filter(function () {
            return String($(this).val()) === value;
        }).prop('checked', false);

        //re-check "all"
        var $all = $group.filter('[value="all"]');
        var anyChecked = $group.not($all).is(':checked');

        if ($all.length && !anyChecked) {
            $all.prop('checked', true);
        }

        // Fade out chip, then submit form
        $chip.stop(true, true).fadeOut(180, function () {
            submitFilters();
        });
    });

    // Search postback scroll
    var params = new URLSearchParams(window.location.search);

    var shouldScroll =
        params.has('keyword') ||
        params.has('news_type')

    var $target = $('#news-filters');

    if (shouldScroll && $target.length) {
        $('html, body').stop().animate({
            scrollTop: $target.offset().top - 16
        }, 350);
    }
});
